import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'file-thumbs',
  templateUrl: './file-thumbs.component.html',
  styleUrls: ['./file-thumbs.component.css']
})
export class FileThumbsComponent implements OnInit, OnChanges {
  @Input() files = [];
  @Input('options') optionsInput:FileThumbsOptions;
  @Output() modal = new EventEmitter<number>();
  constructor() { }
  options:FileThumbsOptions = {
    restrictViewModal: true
  }
  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.optionsInput && changes.optionsInput.currentValue != changes.optionsInput.previousValue){
      for (const [key, value] of Object.entries(this.optionsInput)) {
        this.options[key] = value;
      }
    }
  }

  fileClick(index:number){
    if(!this.options.restrictViewModal) this.modal.emit(index);
  }

  
}

export interface FileThumbsOptions {
  restrictViewModal:boolean;
}
